
    
<template>
    <!-- PC端 -->
	<div v-if="!GLOBAL.isMobile" class="container" v-lazy:background-image="GLOBAL.imgPath + 'login/login_bg.png'">
        <div class="logo-box">
            <router-link to="/" tag="img" :src="'nav/nav_logo.png' | imgsrc"></router-link>
        </div>
		<router-view></router-view>	
        <p class="copyright">2016-2019Aliyun.com 版权所有 浙ICP备16017440号-1</p>
	</div>

    <!-- 手机端 -->
	<el-container v-else class="container-m" v-lazy:background-image="GLOBAL.imgPath + 'login/m_login_bg.png'">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <p class="copyright">2016-2019Aliyun.com 版权所有 浙ICP备16017440号-1</p>
	</el-container>

</template>

<script>
	import GLOBAL from '@/assets/js/global.js'
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			
		},
		mounted() {

		}
	}
</script>

<style scoped lang="scss">
    // PC
	.container {
		position: relative;
		top: 0;
		bottom: 0;
        width: 100vw;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .logo-box {
            width: 1180px;
            margin: 0 auto;
            text-align: left;
            img {
                width: 180px;
                height: 100px;
            }
        }
        .copyright {
            width: 100vw;
            height: 60px;
            background: #F8F9FB;
            color: #C0C0CA;
            font-size: 14px;
            line-height: 60px;
            position: fixed;
            bottom: 0;
            left: 0;
        }
	}
    // 手机
	.container-m {
		position: relative;
		top: 0;
		bottom: 0;
        width: 100vw;
        height: 100vh;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .copyright {
            width: 100vw;
            height: 1.066667rem;
            background: #F8F9FB;
            color: #C0C0CA;
            font-size: 10px;
            line-height: 1.066667rem;
            position: fixed;
            bottom: 0;
            left: 0;
        }
	}



   
</style>




// WEBPACK FOOTER //
// src/components/Login.vue